module.exports = [{"title":"Title"},{"title":"Author"},{"title":"Description"},{"title":"Price"}]


//////////////////
// WEBPACK FOOTER
// ./src/app/components/marketplaceBundle/tableHeaders.json
// module id = 1301
// module chunks = 0